module.exports = __webpack_public_path__ + "media/s p partial colectomy.8b09b80e.wav";